var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3873",
    "data-name": "Group 3873",
    transform: "translate(-87 975.903) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_39426",
    "data-name": "Ellipse 39426",
    transform: "translate(951.903 87)",
    fill: "#fff",
    stroke: "#e0e0e0",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icons8-expand-arrow",
    d: "M5.632,4.131,1.811.31a1.061,1.061,0,0,0-1.5,0h0a1.061,1.061,0,0,0,0,1.5L4.924,6.424a1,1,0,0,0,1.414,0L10.952,1.81a1.061,1.061,0,0,0,0-1.5h0a1.061,1.061,0,0,0-1.5,0Z",
    transform: "translate(966.121 93.5) rotate(90)",
    fill: "#6f6f6f",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group -1.6f91a60fcd682947002859c2e19412d8.svg";
export { ForwardRef as ReactComponent };